import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=25c5c878&"
import script from "./product-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./product-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./product-list.vue?vue&type=style&index=0&id=25c5c878&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports